import { FC, memo } from 'react'

import { Text, CheckCircleIcon, MoneyBagIcon, SellIcon } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'

import * as S from './styles'

const TakeNote: FC = memo(() => (
    <S.Section $bg="medium">
      <Grid col={{ phone: 1, tablet: 1, desktop: 11 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <Text className="subtitle" size="caption" weight="medium" uppercase>
            Para anotar
          </Text>
          <Text as="h2" size="heading3" weight="medium">
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
              Dicas {' '}
            </Text>
            para manter a saúde da sua vida financeira
          </Text>
        </Col>
        <Col col={{ desktop: 3 }} start={{ desktop: 2 }}>
          <S.CardWrapper>
            <CheckCircleIcon color="var(--colors-cyan-icon-default)" />
            <Text as="h3" size="body1" weight="medium">
              Cuide do seu score
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Ficar de olho na sua pontuação de crédito aumenta suas chances de conseguir um empréstimo.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Essa pontuação é importante porque, por ela, as instituições de financiamento avaliam o 
              risco de inadimplência por parte do tomador de crédito.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Para manter seu score sempre alto, é importante pagar todas as contas no prazo.  
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Por isso: ser um bom pagador é essencial na hora de ter seu empréstimo aprovado.
            </Text>
          </S.CardWrapper>
        </Col>
        <Col col={{ desktop: 3 }} start={{ desktop: 5 }}>
          <S.CardWrapper>
            <SellIcon color="var(--colors-cyan-icon-default)" />
            <Text as="h3" size="body1" weight="medium">
              Negocie suas dívidas
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Organizar as dívidas pode ser uma tarefa bastante complicada, não é mesmo? 
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              É por isso que a negociação dos débitos é importante para você se livrar desse grande 
              incômodo.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Quitar as dívidas à vista pode te oferecer condições melhores de pagamento. 
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Para isso, a aquisição de crédito pode ser uma ótima opção para você. Com ela, é possível 
              trocar várias dívidas caras por uma mais barata e iniciar o processo de recuperação da 
              saúde da sua vida financeira. 
            </Text>
          </S.CardWrapper>
        </Col>
        <Col col={{ desktop: 3 }} start={{ desktop: 8 }}>
          <S.CardWrapper>
            <MoneyBagIcon color="var(--colors-cyan-icon-default)" />
            <Text as="h3" size="body1" weight="medium">
              Estabeleça metas financeiras
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Definir objetivos financeiros de curto e longo prazo é um passo importante.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Isso pode incluir pagar dívidas ou criar um fundo de emergência.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Nesses momentos, podemos nos sentir inseguros, não é mesmo?
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Mas não se preocupe, estabelecer metas ajuda a orientar as nossas decisões financeiras e 
              manter o foco.
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Lembre-se de que a saúde financeira é um processo contínuo de aprendizado. 
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Seja consistente com suas práticas financeiras saudáveis e adapte-se de acordo com as 
              necessidades ao longo do tempo.
            </Text>
          </S.CardWrapper>
        </Col>
      </Grid>
    </S.Section>
  )
)

TakeNote.displayName = 'TakeNote'

export default TakeNote
